import styled from "@emotion/styled";
import { Form } from "antd";
import { DisplayText } from "components/lib";
import { useEffect, useState } from "react";

export const DrawTitle = styled(DisplayText)`
  font-weight: 600;
  font-size: 1.8rem;
  height: 4.4rem;
  line-height: 2.5rem;
  position: relative;
  margin-bottom: 1.2rem;
`;

export const DrawForm = styled(Form)`
  margin: 0 1.6rem 0 1.6rem;
`;

export const DrawFormInput = styled.input`
  background: #f5f5f5;
  border-radius: 2.2rem;
  border: none;
  height: 4.4rem;
  width: 100%;
  padding: 1.2rem 1.6rem;
  font-size: 1.4rem;
  color: #1d1b2e;
`;

export const PrefixInput = styled.div`
  position: absolute;
  z-index: 99;
  top: 1.2rem;
  left: 1.8rem;
  color: #1d1b2e;
  padding-right: 1.7rem;
  border-right: 0.5px solid #c0c2cc;
  font-size: 1.4rem;
  line-height: 2rem;
`;

export const useClock = (targetTime = 60) => {
  const [leftTime, setLeftTime] = useState(0);
  const [isBegin, setIsBegin] = useState(false);
  useEffect(() => {
    let passedtime = 0,
      interval: any = null;
    if (!isBegin) {
      setLeftTime(0);
      interval && clearInterval(interval);
      return;
    }
    interval = setInterval(() => {
      passedtime++;
      setLeftTime(targetTime - passedtime);
      if (passedtime === targetTime) {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [isBegin, targetTime]);
  return {
    setIsBegin,
    leftTime,
  };
};
